import { render, staticRenderFns } from "./invoiceApplyDetailEvent.vue?vue&type=template&id=1fb52940&scoped=true"
import script from "./invoiceApplyDetailEvent.vue?vue&type=script&lang=js"
export * from "./invoiceApplyDetailEvent.vue?vue&type=script&lang=js"
import style0 from "./invoiceApplyDetailEvent.vue?vue&type=style&index=0&id=1fb52940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb52940",
  null
  
)

export default component.exports